var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* ログインID変更 */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../molecules/Block';
import Annotation from '../atoms/Annotation';
import axios from '../axios';
import { Row, Col } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../organisms/LoadingModal';
import { Modal, Button } from 'react-bootstrap';
import { jumpUrl } from '../Common';
var mypage_login_url = '/mypage/login';
var LoginIdComplete = function () {
    var _a = useState(''), error_message = _a[0], setErrorMessage = _a[1];
    var _b = useState(false), show = _b[0], setShow = _b[1];
    var _c = useState(false), is_loading = _c[0], setIsLoading = _c[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
    }, []);
    // キャンセルボタン
    var handleClickCacncel = function () {
        var handleCancel = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        return [4 /*yield*/, axios.put('login_id/cancel')];
                    case 1:
                        _a.sent();
                        location.replace("" + location.origin + process.env.MIX_MOCK_URL + mypage_login_url);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        jumpUrl(error_1.response.data.url);
                        setErrorMessage(error_1.response.data.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        handleCancel();
    };
    // 確定ボタン
    var handleChangeFix = function () {
        var handleChangeFix = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        return [4 /*yield*/, axios.put('login_id/confirm')];
                    case 1:
                        _a.sent();
                        // 完了ダイアログを表示
                        setShow(true);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.log(error_2.response);
                        if (error_2.response.status === 401) {
                            if (error_2.response.data.role_error_flg) {
                                // 権限エラー (行員のログイン画面へ遷移)
                                location.replace("" + location.origin + process.env.MIX_MOCK_URL + "/login");
                            }
                            else {
                                // 認証エラー (申込人のログイン画面へ遷移)
                                location.replace("" + location.origin + process.env.MIX_MOCK_URL + mypage_login_url);
                            }
                        }
                        setErrorMessage(error_2.response.data.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        handleChangeFix();
    };
    // 完了ダイアログでOKをクリックしたらログイン画面へ遷移
    var handleClickOk = function () {
        setShow(false);
        location.replace("" + location.origin + process.env.MIX_MOCK_URL + "/mypage/login");
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-5" }),
        React.createElement(Block, { label: "\u30ED\u30B0\u30A4\u30F3ID\u5909\u66F4\u5B8C\u4E86", content: React.createElement(React.Fragment, null,
                React.createElement(Annotation, { text: "\u30ED\u30B0\u30A4\u30F3ID\u306E\u5909\u66F4\u3092\u5B8C\u4E86\u3059\u308B\u306B\u306F\u300C\u78BA\u5B9A\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u4E0B\u3057\u3066\u304F\u3060\u3055\u3044\u3002" }),
                React.createElement(Annotation, { text: "\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u65B0\u3057\u3044\u30ED\u30B0\u30A4\u30F3ID\u3067\u30ED\u30B0\u30A4\u30F3\u64CD\u4F5C\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002" }),
                React.createElement("div", { className: "w-75 p-3" }),
                React.createElement(Annotation, { text: "\u30ED\u30B0\u30A4\u30F3ID\u306E\u5909\u66F4\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B\u5834\u5408\u306F\u3001\u300C\u30AD\u30E3\u30F3\u30BB\u30EB\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u4E0B\u3057\u3066\u304F\u3060\u3055\u3044\u3002" }),
                React.createElement(Annotation, { text: "\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u5909\u66F4\u524D\u306E\u30ED\u30B0\u30A4\u30F3ID\u3067\u30ED\u30B0\u30A4\u30F3\u64CD\u4F5C\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002" }),
                React.createElement("div", { className: "mt-3" }),
                typeof error_message !== 'undefined' && (
                // エラー表示
                React.createElement(Row, { className: "d-flex align-items-center justify-content-center" },
                    React.createElement(Col, null),
                    React.createElement(Col, { md: 9, className: "alert-danger alert-danger-custom" }, error_message))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md" },
                        React.createElement("div", { className: "p-back-btn-box " },
                            React.createElement("a", { className: "c-btn btn-large btn-red", onClick: handleClickCacncel }, "\u30AD\u30E3\u30F3\u30BB\u30EB"))),
                    React.createElement("div", { className: "col-md-4 ml-auto" }),
                    React.createElement("div", { className: "col-md-auto" },
                        React.createElement("div", { className: "p-back-btn-box" },
                            React.createElement("a", { className: "c-btn btn-large btn-main-color", onClick: handleChangeFix }, "\u78BA\u5B9A"))))) }),
        React.createElement(React.Fragment, null,
            React.createElement(Modal, { className: "d-flex align-items-center", show: show, animation: false },
                React.createElement(Modal.Header, null,
                    React.createElement(Modal.Title, { className: "dialog-title" }, "\u30ED\u30B0\u30A4\u30F3ID\u306E\u5909\u66F4\u304C\u5B8C\u4E86")),
                React.createElement(Modal.Body, { className: "dialog-body" }, "\u30ED\u30B0\u30A4\u30F3ID\u306E\u5909\u66F4\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"),
                React.createElement(Modal.Footer, null,
                    React.createElement(Button, { variant: "primary", onClick: handleClickOk }, "OK")))),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('login-id-complete')) {
    ReactDOM.render(React.createElement(LoginIdComplete, null), document.getElementById('login-id-complete'));
}
